/*!

=========================================================
* Argon Design System React - v1.1.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap ../../components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";
import {handleGoogleLogin, handleGoogleLogOut, handleEmailRegister} from '../../components/G_Auth.js'

// core ../../components
import DemoNavbar from "../../components/Navbars/DemoNavbar.js";
import SimpleFooter from "../../components/Footers/SimpleFooter.js";


import {TermsButton} from '../../termsButton'
import {TermsPopup} from '../../termsPopup'


class Register extends React.Component {

constructor(props) {
super(props);
this.state = {
    name: '',
    email: '',
    password: '',
    termsAccepted:false,
    showTermsPopup: false  // New state to control visibility of TermsPopup
  };
//    termsAccepted: false,  // New state to track acceptance of Terms and Conditions
  }

  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
    const g_button = document.getElementById("igoogle-register-button");
    g_button.addEventListener("click", handleGoogleLogin);

    }
   
    /*  ---- Move to Components later --------- */
    handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
    };
    
    handleCheckboxChange = (e) => {
      const { name, checked } = e.target;
      this.setState({
        [name]: checked
      }, () => {
//        console.log('termsAccepted = ', this.state.termsAccepted); // Log updated termsAccepted state
      });
    };
  

  toggleTermsPopup = () => {
    this.setState((prevState) => ({
      showTermsPopup: !prevState.showTermsPopup
    }));
  };
  
   toggleCGTermsPopup = () => {
    this.setState((prevState) => ({
      showCGTermsPopup: !prevState.showCGTermsPopup
    }));
  }; 
    handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, password, termsAccepted } = this.state;
    if (this.state.termsAccepted) {
       handleEmailRegister({name, email, password})
       }
    else
    {
        alert("Accept Terms and conditions ");
    }
 
  };
  /*  ---- Move to Components later --------- */
  render() {
    const {termsAccepted,showTermsPopup} = this.state;
    return (
      <>
        <DemoNavbar />
        <main ref="main">
          <section className="section section-shaped section-lg">
            <div className="shape shape-style-1 bg-gradient-default">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            <Container className="pt-lg-7">
              <Row className="justify-content-center">
                <Col lg="6">
                  <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-white pb-5">
                      <div className="text-muted text-center mb-3">
                        <small>Sign up with</small>
                      </div>
                      <div className="text-center">
                        <Button
                          className="btn-neutral btn-icon mr-4"
                          color="default"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          <span className="btn-inner--icon mr-1">
                            <img
                              alt="..."
                              src={
                                require("../../assets/img/icons/common/github.svg")
                                  .default
                              }
                            />
                          </span>
                          <span className="btn-inner--text">Github</span>
                        </Button>
                        <Button
                          className="btn-neutral btn-icon ml-1"
                          color="default"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                          id="igoogle-register-button"
                        >
                          <span className="btn-inner--icon mr-1">
                            <img
                              alt="..."
                              src={
                                require("../../assets/img/icons/common/google.svg")
                                  .default
                              }
                            />
                          </span>
                          <span className="btn-inner--text">Google</span>
                        </Button>
                      </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="text-center text-muted mb-4">
                        <small>Or sign up with credentials</small>
                      </div>
                      <Form role="form" onSubmit={this.handleSubmit}>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-hat-3" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Name"
                              type="text"
                              name="name"
                              value={this.state.name}
                              onChange={this.handleChange}
                            />                            
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative mb-3">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-email-83" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Email"
                              type="email"
                              name="email"
                              value={this.state.email}
                              onChange={this.handleChange}
                            />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-lock-circle-open" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Password"
                              type="password"
                              name="password"
                              value={this.state.password}
                              autoComplete="off"
                              onChange={this.handleChange}
                            />
                          </InputGroup>
                        </FormGroup>
                        <div className="text-muted font-italic">
                          <small>
                            password strength:{" "}
                            <span className="text-success font-weight-700">
                              --
                            </span>
                          </small>
                        </div>
                        <Row className="my-4">
                          <Col xs="12">
                            <div className="custom-control custom-control-alternative custom-checkbox">
                              <input
                                className="custom-control-input"
                                id="customCheckRegister"
                                type="checkbox"
                                name="termsAccepted"
                                checked={termsAccepted}
                                onChange={this.handleCheckboxChange}                        
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="customCheckRegister"
                              >
                                <span>
                                  I agree with the{" "}
                                  <a href="#" onClick={(e) => {e.preventDefault();this.toggleTermsPopup();}}>
                                    Terms and Conditions
                                  </a>
                                </span>
			      
                              </label>
                            </div>
                          </Col>
                        </Row>
                        <div className="text-center">
                          <Button
                          className="mt-4"
                          color="primary"
                          type="submit"
                          disabled={!this.state.termsAccepted}  // Disable button if terms not accepted
                        >
                            Create account
                          </Button>
                        </div>
                        {showTermsPopup && <TermsPopup onClose={this.toggleTermsPopup} />}                        
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        <SimpleFooter />
      </>
    );
  }
}

export default Register;
